/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForKubernetesClusterBilling extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForKubernetesClusterBilling");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForKubernetesClusterBilling.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForKubernetesClusterBilling>): BackgroundJobPayloadForKubernetesClusterBilling {
        let obj = Object.assign(new BackgroundJobPayloadForKubernetesClusterBilling(), model);
        BackgroundJobPayloadForKubernetesClusterBilling.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForKubernetesClusterBilling>): BackgroundJobPayloadForKubernetesClusterBilling {
        if (!model) return null;
        return BackgroundJobPayloadForKubernetesClusterBilling.newInstance(<BackgroundJobPayloadForKubernetesClusterBilling> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForKubernetesClusterBilling) {
        if (!obj) return;

        models.BackgroundJobPayloadForKubernetesClusterBilling.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForKubernetesClusterBilling): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForKubernetesClusterBilling.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Parent Cloud Account for the Kubernetes Cluster
     */
    service_account_id: string;

}
